<template>
  <div class="not-found">
    <h1 class="display-4">404</h1>
  </div>
</template>

<script>
  export default {
    name: "PageNotFound"
  };
</script>

<style lang="scss">
  .not-found {
    display: flex;
    align-items: center !important;
    justify-content: center !important;
    font-family: 'ZX', serif !important;
    [class*=display] {
      font-family: 'ZX', serif !important;
    }
  }
</style>
